'use client';

import { Archive } from 'lucide-react';
import {
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '../../../components/accordion';
import { Checkbox } from '../../../components/checkbox';
import { useFilter } from '../filter-provider';
import { TravelCompanion, ThreesomeStatuses } from '@bells/types/attendant';
import { attendantFilterServices } from '@bells/i18n';
import { useMemo } from 'react';

export default function FilterServices() {
  const { filters, setFilters, locale } = useFilter();

  const services = useMemo(() => ThreesomeStatuses(locale), [locale]);
  const travelCompanion = useMemo(() => TravelCompanion(locale), [locale]);

  return (
    <AccordionItem value='services'>
      <AccordionTrigger className='px-2 py-3 text-sm font-normal text-muted-foreground hover:text-foreground'>
        <div className='inline-flex flex-1 items-center gap-2'>
          <Archive className='h-4 w-4' />
          {attendantFilterServices()}
        </div>
      </AccordionTrigger>
      <AccordionContent className='space-y-4 px-4'>
        <div className='flex w-full items-center space-x-2'>
          <Checkbox
            id='travelCompanion'
            checked={filters.travelCompanion === true}
            onCheckedChange={(val) => {
              setFilters({
                ...filters,
                page: 1,
                travelCompanion: val ? true : undefined,
              });
            }}
          />
          <label
            htmlFor='travelCompanion'
            className='flex-1 break-words text-sm font-normal leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70'
          >
            {travelCompanion}
          </label>
        </div>
        {services.map((service) => (
          <div
            key={`services-${service.value}`}
            className='flex w-full items-center space-x-2'
          >
            <Checkbox
              id={service.value}
              checked={(filters.services ?? []).includes(service.value)}
              onCheckedChange={(val) => {
                let arr = filters.services ?? [];
                if (!val) {
                  arr = arr.filter((v) => v !== service.value);
                } else {
                  arr.push(service.value);
                }
                setFilters({
                  ...filters,
                  page: 1,
                  services: arr.length > 0 ? arr : undefined,
                });
              }}
            />
            <label
              htmlFor={service.value}
              className='flex-1 break-words text-sm font-normal leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70'
            >
              {service.label}
            </label>
          </div>
        ))}
      </AccordionContent>
    </AccordionItem>
  );
}
